(function () {
  var STORAGE_KEY = 'platex_audience';
  var MANUAL_NAV_KEY = 'platex_adp_manual';
  var B2B_SEARCH_PARAM = 'filter.p.m.custom.is_b2b';
  var B2B_SEARCH_TRUE_VALUE = '1';
  var B2B_SEARCH_FALSE_VALUE = '0';

  function setAudienceCookie(value) {
    if (!value) return;
    document.cookie = STORAGE_KEY + '=' + encodeURIComponent(value) + '; path=/; max-age=31536000; SameSite=Lax';
  }

  function getAudienceCookie() {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0] === STORAGE_KEY) {
        return decodeURIComponent(parts.slice(1).join('='));
      }
    }
    return '';
  }

  function setAudience(value) {
    if (!value) return;
    localStorage.setItem(STORAGE_KEY, value);
    setAudienceCookie(value);
    applyAudienceAttribute(value);
  }

  function getAudience() {
    return getAudienceCookie() || localStorage.getItem(STORAGE_KEY);
  }

  function isB2bAudience() {
    return getAudience() === 'b2b';
  }

  function applyAudienceAttribute(value) {
    if (value === 'b2b' || value === 'b2c') {
      document.documentElement.setAttribute('data-platex-audience', value);
    }
  }

  function getB2bSearchFilterValue(forced) {
    if (forced === 'true') return B2B_SEARCH_TRUE_VALUE;
    return isB2bAudience() ? B2B_SEARCH_TRUE_VALUE : B2B_SEARCH_FALSE_VALUE;
  }

  function normalizePath(url) {
    if (!url) return '';
    try {
      var a = document.createElement('a');
      a.href = url;
      var p = a.pathname || '/';
      if (p.length > 1 && p.charAt(p.length - 1) === '/') {
        p = p.slice(0, -1);
      }
      return p;
    } catch (e) {
      return url;
    }
  }

  function getHomeAudience(overlay) {
    var current = normalizePath(window.location.pathname);
    var b2cPath = normalizePath(overlay.dataset.b2cUrl);
    var b2bPath = normalizePath(overlay.dataset.b2bUrl);
    if (b2bPath && current === b2bPath) return 'b2b';
    if (b2cPath && current === b2cPath) return 'b2c';
    return null;
  }

  function syncB2bSearchForm(form) {
    var input = form.querySelector('[data-adp-b2b-search-filter]');
    if (!input) return;

    input.value = getB2bSearchFilterValue(input.dataset.adpB2bFilterForced);
    input.disabled = false;
  }

  function initB2bSearchForms() {
    document.querySelectorAll('[data-adp-search-form]').forEach(function (form) {
      syncB2bSearchForm(form);
      form.addEventListener('submit', function () {
        syncB2bSearchForm(form);
      }, true);
    });
  }

  function initB2bSearchLinks() {
    document.querySelectorAll('[data-adp-search-link]').forEach(function (link) {
      var value = getB2bSearchFilterValue(link.dataset.adpB2bFilterForced);
      try {
        var url = new URL(link.href, window.location.origin);
        url.searchParams.set(B2B_SEARCH_PARAM, value);
        link.href = url.toString();
      } catch (e) {
        link.href = link.href + (link.href.indexOf('?') === -1 ? '?' : '&') + B2B_SEARCH_PARAM + '=' + value;
      }
    });
  }

  function showPopup(overlay) {
    console.log('[ADP] showing popup');
    overlay.classList.add('adp-overlay--visible');
    document.body.style.overflow = 'hidden';
    overlay.querySelectorAll('[data-audience]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var choice = btn.dataset.audience;
        var pageAudience = overlay.dataset.pageAudience === 'true' ? 'b2b' : 'b2c';
        var pageAudienceMode = overlay.dataset.pageAudienceMode;
        console.log('[ADP] click — choice:', choice, '| pageAudience:', pageAudience);
        setAudience(choice);
        if (pageAudienceMode === 'cookie') {
          console.log('[ADP] cookie-driven page, closing popup');
          overlay.classList.remove('adp-overlay--visible');
          document.body.style.overflow = '';
          return;
        }
        if (choice !== pageAudience) {
          var target = choice === 'b2b' ? overlay.dataset.b2bUrl : overlay.dataset.b2cUrl;
          console.log('[ADP] redirecting to', target);
          window.location.href = target;
        } else {
          console.log('[ADP] same audience, closing popup');
          overlay.classList.remove('adp-overlay--visible');
          document.body.style.overflow = '';
        }
      });
    });
  }

  function init() {
    var overlay = document.getElementById('adp-overlay');
    if (!overlay) {
      console.log('[ADP] overlay element not found, popup disabled');
      return;
    }

    var saved = getAudience();
    applyAudienceAttribute(saved);
    var pageAudience = overlay.dataset.pageAudience === 'true' ? 'b2b' : 'b2c';
    var homeAudience = getHomeAudience(overlay);
    var manualNav = sessionStorage.getItem(MANUAL_NAV_KEY) === '1';
    if (manualNav) {
      sessionStorage.removeItem(MANUAL_NAV_KEY);
    }
    console.log('[ADP] init — saved:', saved, '| pageAudience:', pageAudience, '| homeAudience:', homeAudience, '| manualNav:', manualNav);

    if (saved && homeAudience && saved !== homeAudience && !manualNav) {
      var target = saved === 'b2b' ? overlay.dataset.b2bUrl : overlay.dataset.b2cUrl;
      console.log('[ADP] auto-redirect home → ', target);
      window.location.replace(target);
      return;
    }

    if (!saved) {
      showPopup(overlay);
    } else {
      console.log('[ADP] profile already saved, no popup');
    }
  }

  function initSwitchLinks() {
    document.querySelectorAll('[data-adp-switch-to]').forEach(function (link) {
      link.addEventListener('click', function () {
        var target = link.dataset.adpSwitchTo;
        setAudience(target);
        sessionStorage.setItem(MANUAL_NAV_KEY, '1');
        console.log('[ADP] switch-link → audience set to', target, '| manual flag set');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    init();
    initSwitchLinks();
    initB2bSearchForms();
    initB2bSearchLinks();
  });
})();
